/*
  Relabels every "add the deck" button from what's already in the bag (config from
  snippets/pt-deck-cta.liquid). With 0 decks nothing changes. With 1, a 1-deck button
  reads "Make it a 2-Pack — +$15.00" and 2-Pack buttons hide; with 2+, "Add a 3rd deck"
  / "Add another deck" at the 3+ price. Prices are what the click adds to the cart
  total under the automatic discounts, so they always match checkout.
  Runs on load, and again after any cart change (cart pop-up, product forms, cart page).
  The deck page's pack picker (snippets/pt-bundle-picker) listens for 'pt:deck-bag'.
*/
(() => {
  const cfg = window.ptDeck;
  if (!cfg) return;

  const fmt = (cents) => `$${(cents / 100).toFixed(2)}`;
  const total = (n) => (n <= 0 ? 0 : n === 1 ? cfg.single : n === 2 ? cfg.pair : n * cfg.threePlusEach);
  const added = (n, k) => total(n + k) - total(n);

  // Copy for a button that adds k decks when n are already in the bag; null keeps the original.
  const copyFor = (n, k) => {
    if (n < 1) return null;
    const price = `+${fmt(added(n, k))}`;
    if (n === 1 && k === 1) return { main: 'Make it a 2-Pack', price, sub: `2 decks for ${fmt(cfg.pair)}` };
    const sub = `${fmt(cfg.threePlusEach)} each at 3+`;
    if (k === 1) return { main: n === 2 ? 'Add a 3rd deck' : 'Add another deck', price, sub };
    return { main: `Add ${k} more decks`, price, sub };
  };

  const isDeckForm = (form) =>
    (form.getAttribute('action') || '').includes('/cart/add') &&
    Number(form.querySelector('input[name="id"]')?.value) === cfg.variantId;

  // The cart pop-up only offers the deck when there isn't one; the deck page's main
  // form is driven by the pack picker.
  const skip = (form) => form.closest('cart-notification, product-info');

  const relabel = (button, copy) => {
    if (button.dataset.ptDeckOrig === undefined) button.dataset.ptDeckOrig = button.innerHTML;
    if (!copy) {
      if (button.dataset.ptDeckLabeled) {
        button.innerHTML = button.dataset.ptDeckOrig;
        delete button.dataset.ptDeckLabeled;
      }
      return;
    }
    button.innerHTML = button.dataset.ptDeckOrig;
    const main = button.querySelector('.pt-cta-text, .pt-video-cta-main');
    if (main) {
      // Stacked buttons (title / sub line / price row): keep their layout.
      main.textContent = `${copy.main} — ${copy.price}`;
      const sub = button.querySelector('.pt-cta-sub, .pt-video-cta-sub');
      if (sub) sub.textContent = copy.sub;
      button.querySelectorAll('.pt-price-row').forEach((row) => row.style.setProperty('display', 'none', 'important'));
    } else {
      const spinner = button.querySelector('.loading__spinner')?.outerHTML || '';
      button.innerHTML = `<span>${copy.main} — ${copy.price}</span>${spinner}`;
    }
    button.dataset.ptDeckLabeled = '1';
  };

  const apply = (n) => {
    cfg.inBag = n;
    document.querySelectorAll('form').forEach((form) => {
      if (!isDeckForm(form) || skip(form)) return;
      const k = Math.max(1, Number(form.querySelector('input[name="quantity"]')?.value) || 1);
      if (k >= 2) {
        // Gift 2-Pack buttons: with a deck already in the bag the 1-deck button completes the pack.
        form.style.display = n >= 1 ? 'none' : '';
        return;
      }
      const copy = copyFor(n, k);
      const id = form.getAttribute('id');
      const buttons = [...form.querySelectorAll('[type="submit"]')];
      if (id) buttons.push(...document.querySelectorAll(`[type="submit"][form="${CSS.escape(id)}"]`));
      buttons.forEach((button) => relabel(button, copy));
      form.querySelectorAll('.pbt-deck__price-row').forEach((row) => (row.style.display = copy ? 'none' : ''));
    });
    document.dispatchEvent(new CustomEvent('pt:deck-bag', { detail: { inBag: n, added, fmt, cfg } }));
  };

  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) =>
          apply(
            (cart.items || [])
              .filter((item) => Number(item.variant_id) === cfg.variantId)
              .reduce((sum, item) => sum + item.quantity, 0)
          )
        )
        .catch(() => {});
    }, 150);
  };

  document.addEventListener('pt:cart-changed', refresh);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  // Back/forward cache restores a stale page.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh();
  });

  apply(cfg.inBag);
})();
